import { Option, none, some } from "./option";
import { Result, isOk } from "./result";

enum PromiseSettledResultStatus {
	Pending = "pending",
	Fulfilled = "fulfilled",
	Rejected = "rejected",
}
/**
 * Extracts a value from a settled promise containing a Result, falling back to a default value if unsuccessful
 * @param promise - A settled promise containing a Result of type T or error E
 * @param defaultValue - The fallback value to return if the promise was rejected or contains an Err
 * @returns The contained value if successful, otherwise the default value
 */
export function fromSettledPromiseOr<T, E = Error>(
	promise: PromiseSettledResult<Result<T, E>>,
	defaultValue: T,
): T {
	if (
		promise.status === PromiseSettledResultStatus.Fulfilled &&
		isOk(promise.value)
	) {
		return promise.value.value;
	}

	return defaultValue;
}
/**
 * Converts a settled promise containing a Result into an Option
 * @param promise - A settled promise containing a Result of type T or error E
 * @returns Some(value) if the promise was fulfilled and contains Ok(value), None otherwise
 */
export function fromSettledPromise<T, E = Error>(
	promise: PromiseSettledResult<Result<T, E>>,
): Option<T> {
	if (
		promise.status === PromiseSettledResultStatus.Fulfilled &&
		isOk(promise.value)
	) {
		return some(promise.value.value);
	}

	return none();
}
